import React from 'react';
export function Footer() {
  return <footer className="bg-amber-950 text-amber-200/60 py-12 text-sm" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6" data-id="element-73">
        <div className="flex flex-wrap justify-center gap-6" data-id="element-74">
          <a href="#" className="hover:text-amber-100 transition-colors" data-id="element-75">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-amber-100 transition-colors" data-id="element-76">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-amber-100 transition-colors" data-id="element-77">
            Contacto
          </a>
        </div>

        <div className="max-w-2xl mx-auto border-t border-amber-900 pt-6" data-id="element-78">
          <p className="mb-2" data-id="element-79">
            © 2026 Quincena Milagrosa. Todos los derechos reservados.
          </p>
          <p className="text-xs opacity-70" data-id="element-80">
            Este producto es un material educativo. Los resultados pueden variar
            según la aplicación de cada persona. No constituye asesoría
            financiera profesional personalizada.
          </p>
        </div>
      </div>
    </footer>;
}